import { FormControl, InputLabel, Select, MenuItem, Grid, Typography } from "@mui/material"

const DateYearSelect = ({label, name, index, value, handleOnChange, yearOnly = false}) =>{
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
    const currentYear = new Date().getUTCFullYear() 
    return <><Typography pb={2}>{label}</Typography>
    <Grid item xs={12} sx={{display: 'flex'}}>
      {!yearOnly && <Grid item xs={6} pr={2}>
      <FormControl fullWidth>
      <InputLabel id="month">Month</InputLabel>
      <Select
        labelId="month"
        id="month"
        value={value[1]}
        label="Month"
        onChange={(e)=>handleOnChange(name, e.target.value, index, 'month')}
      >
        {months.map((month, index)=>{
          return <MenuItem key={index} value={month}>{month}</MenuItem>
        })}
      </Select>
      </FormControl>
    </Grid>}
    <Grid item xs={yearOnly? 12 : 6}>
      <FormControl fullWidth>
      <InputLabel id="year">Year</InputLabel>
      <Select
        labelId="year"
        id="year"
        value={value[0]}
        label="year"
        onChange={(e)=>handleOnChange(name, e.target.value, index, 'year')}
      >
        {Array(currentYear - (currentYear - 20)).fill('').map((year, index)=>{
          return <MenuItem key={index} value={currentYear - index}>{currentYear - index}</MenuItem>
        })}
      </Select>
      </FormControl>
    </Grid>
  </Grid></>
}

export default DateYearSelect